import { Timestamp } from 'src/types'
import { TIME_IN_MS } from 'src/constants'

export const timestampToDate = (timestamp: Timestamp): Date => {
  return new Date(timestamp.seconds * TIME_IN_MS.SECOND)
}
